import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { toast } from "react-toastify";
import { PickList } from "primereact/picklist";
import { Button, Col, Container, OverlayTrigger, Row, Spinner, Tooltip } from "react-bootstrap"
import { ContentBody } from "../../styled"
import { CustomPickList } from "../../products/components/picklist-form/styled";

import { HiOutlineArrowCircleLeft } from "react-icons/hi";
import { MdErrorOutline } from "react-icons/md";
import { getCourse, getDisciplinesToSync, getPhase, syncDisciplines } from "../../../../services/manager/admin/courses.service";

export const SyncDisciplines = (): JSX.Element => {
  const history = useHistory();
  const { t: translation } = useTranslation();
  const queryParams = new URLSearchParams(window.location.search)
  const courseId = queryParams.get("courseId")
  const faseId = queryParams.get("faseId")

  const [loading, setLoading] = useState<boolean>(true);
  const [loadingButton, setLoadingButton] = useState<boolean>(false);
  const [isStore, setIsStore] = useState<boolean>(false);
  const [course, setCourse] = useState<any>();
  const [phase, setPhase] = useState<any>();

  const [source, setSource] = useState<any[]>([]);
  const [target, setTarget] = useState<any[]>([]);

  const onChange = (event: any) => {
    if (isStore) {
      let newSource: any = event.source
      let newTarget: any = event.target.filter((x: any) => x.price !== null)
      
      event.target.map((item: any) => {
        if (item.price === null) {
          let index = source.indexOf(item)
          newSource.splice(index, 0, item)
        }
      })
  
      setSource(newSource);
      setTarget(newTarget);
    } else {
      setSource(event.source);
      setTarget(event.target);
    }
  }

  const onSubmit = () => {
    setLoadingButton(true)
    let arr: any[] = []
    target.map((item: any) => {
      arr.push(item.id)
    })
    
    if (courseId) {
      let obj = {
        disciplines: arr
      }

      syncDisciplines(courseId, obj).then((resp: any) => {
        if (arr.length === 1) {
          toast.success("Disciplina vinculada com sucesso!");
        } else {
          toast.success("Disciplinas vinculadas com sucesso!");
        }
        history.goBack();
      }).catch((err: any) => {
        toast.error("Ocorreu um erro ao tentar vincular as disciplinas. Tente novamente.");
      }).finally(() => {
        setLoadingButton(false)
      })
    } else if (faseId) {
      let obj = {
        disciplines: arr,
        step: faseId
      }

      syncDisciplines(course.id, obj).then((resp: any) => {
        toast.success("Disciplinas vinculadas com sucesso!");
        history.goBack();
      }).catch((err: any) => {
        toast.error("Ocorreu um erro ao tentar vincular as disciplinas. Tente novamente.");
      }).finally(() => {
        setLoadingButton(false)
      })
      
    }
  }

  const itemTemplate = (item: any) => {
    return (
      <Row className="product-details">
        <Col md={10}>
          <p className={`${item.price === null && isStore ? "text-grey" : "text-black "} mb-2`}>{item.title}</p>
        </Col>

        {
          item.price === null && isStore &&
          <Col md={2} className="text-end">
            <OverlayTrigger placement={'top'} overlay={<Tooltip>{translation('manager.syncDisciplines.noPrice')}</Tooltip>}>
              <span>
                <MdErrorOutline size="20" style={{ color: "#DD7B2A" }}/>
              </span>
            </OverlayTrigger>
          </Col>
        }
      </Row>
    );
  }

  const getCourseInfo = (id: any) => {
    setLoading(true)
    getCourse(id).then((course: any) => {
      setCourse(course)

      if (courseId && course.disciplines) {
        let arr: any = []
        course.disciplines.map((discipline: any) => {
          let obj = {
            id: discipline.discipline_id,
            order: discipline.order,
            title: discipline.title
          }
          arr.push(obj)
        })
        setTarget(arr)
      } else if (faseId) {
        course.steps.map((step: any) => {
          if (step.id === parseInt(faseId)) {
            if (step.disciplines.length > 0) {
              setTarget(step.disciplines)
            }
          }
        })
      }

      getDisciplinesToSync(id).then((resp: any) => {
        setSource(resp.disciplines)
        setIsStore(resp.is_store)
      })
    }).finally(() => {
      setLoading(false)
    })
  }
  
  useEffect(() => {
    if (courseId) {
      getCourseInfo(courseId);
    } else if (faseId) {
      getPhase(parseInt(faseId)).then((phase) => {
        setPhase(phase)
        getCourseInfo(phase.course);
      })
    }
  }, [])

  return (
    <Container fluid>
      <Row>
        <Col>
        <h4>
          <OverlayTrigger
            placement={'top'}
            overlay={<Tooltip>Voltar</Tooltip>}
          >
            <span>
              <HiOutlineArrowCircleLeft size={25} style={{ marginRight: '10px', marginBottom: '6px', cursor: 'pointer' }} onClick={() => history.goBack()}/>
            </span>                  
          </OverlayTrigger>
            {
              faseId ? (
                <b>{course?.name} / {phase?.name} / <span className="font-20">{translation('manager.syncDisciplines.addDisciplines')}</span></b>
              ) : (
                <b>{course?.name} / <span className="font-20">{translation('manager.syncDisciplines.addDisciplines')}</span></b>
              )
            }
          </h4>
          <p className="mb-5 text-black font-light">{translation('manager.syncDisciplines.description')}</p>
        </Col>
      </Row>
      <ContentBody>
        {
          loading ? (
            <div className="loading-container mt-5">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              <CustomPickList>
                <PickList 
                  source={source} target={target} itemTemplate={itemTemplate} 
                  onChange={onChange} targetHeader={courseId ? translation('manager.syncDisciplines.myCourse') : translation('manager.syncDisciplines.myFase')}
                  showSourceControls={false} showTargetControls={false} className="w-100 pick-sync-disciplines"
                  filterBy="title" sourceFilterPlaceholder={translation('manager.syncDisciplines.search')} targetFilterPlaceholder={translation('manager.syncDisciplines.search')}
                  sourceHeader={<span>{translation('manager.syncDisciplines.availableDisciplines')} 
                    <OverlayTrigger 
                      placement={'top'} 
                      overlay={<Tooltip>{translation('manager.syncDisciplines.tooltipDisciplines')}</Tooltip>}
                    >
                      <span className="ml-2">
                        <MdErrorOutline size="20" className="mb-1"/>
                      </span>
                    </OverlayTrigger></span>
                  }
                />
              </CustomPickList>

              <Col xs={12} className="mt-3 mb-3 text-end">
                {
                  loadingButton ? (
                    <Spinner animation="border" variant="primary" style={{ width: '2rem', height: '2rem', borderWidth: '0.25em', borderRightColor: 'transparent' }} />
                  ) : (
                    <>
                      <Button variant="outline-primary" className="mr-2" onClick={() => history.goBack()}>{translation('cancel')}</Button>
                      <Button variant="primary" onClick={() => onSubmit()}><span className="ml-2 mr-2">{translation('save')}</span></Button>
                    </>
                  )
                }
              </Col>
            </>
          )
        }
      </ContentBody>
    </Container>
  )
}